/** @format */
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { Attainment, CustomCourseUnitAttainment } from 'common-typescript/types';

@Component({
    selector: 'app-custom-course-unit-attainment-details',
    templateUrl: './custom-course-unit-attainment-details.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class CustomCourseUnitAttainmentDetailsComponent {
    @Input() attainment: CustomCourseUnitAttainment;
    @Input() secondaryAttainments: Attainment[];
    @Input() expirationImminent: boolean;
}
